import { useNavigate } from 'react-router-dom';

/**
 * "Continue to booking" card — the deliverable of the concierge desk's live
 * flight search (server/tommy-flight-search.js). One tap navigates to
 * /flightoptions with the exact same location.state payload the Book page
 * (GoogleFlightsSearch.jsx) builds, so checkout proceeds as if the customer
 * had searched and selected the itinerary themselves. The booking token
 * inside can expire (SerpAPI mints them per search); a stale tap lands on
 * FlightOptions' existing "search again" error path, never a broken screen.
 */
export default function FlightHandoffCard({ handoff }) {
  const navigate = useNavigate();
  const s = handoff?.summary || {};
  if (!handoff?.navState) return null;
  const metaLine = [
    s.airline,
    s.cabin,
    s.travelers > 1 ? `${s.travelers} travelers` : null,
  ].filter(Boolean).join(' · ');
  return (
    <div className="mt-2 w-full rounded-2xl border border-brand-800/45 bg-brand-950/95 backdrop-blur-xl p-4 shadow-2xl">
      <p className="text-sm font-medium text-white truncate">
        {s.route}{s.dates ? ` · ${s.dates}` : ''}
      </p>
      {metaLine && <p className="text-xs font-normal text-white/55 mt-0.5 truncate">{metaLine}</p>}
      {(s.depositLabel || s.totalLabel) && (
        <p className="text-xs font-normal text-white/70 mt-1.5">
          {[s.depositLabel, s.totalLabel].filter(Boolean).join(' · ')}
        </p>
      )}
      <button
        type="button"
        onClick={() => navigate('/flightoptions', { state: handoff.navState })}
        className="mt-3 w-full h-10 rounded-full text-sm font-medium text-white bg-[hsl(228,62%,50%)] hover:bg-[hsl(228,62%,44%)] shadow-[0_0_16px_hsla(228,70%,55%,0.35)] transition-colors"
      >
        Continue to booking
      </button>
    </div>
  );
}
